export const USER_ROLES = [
  {
    id: 0,
    name: 'Пользователь',
  },
  {
    id: 1,
    name: 'Пользователь',
  },
  {
    id: 2,
    name: 'Администратор',
  },
  {
    id: 3,
    name: 'Супер-Администратор',
  },
  {
    id: 4,
    name: 'Владелец',
  },
];
